<template>
  <div>

    <dashboard-header
      class="white elevation-1"
      :doctorName="doctorName"
    ></dashboard-header>

    <v-container
      class="mb-3"
    >
      <v-card
        class="pa-5"
      >
        <v-layout>
          <v-flex>
            <div class="display-1 mb-3">
              <strong style="color: #800080;text-transform: uppercase;">{{ moduleData.title }}</strong>
            </div>
            <div class="subtitle mb-5">
              {{ moduleData.description }}<br/>
              <span>Author: </span><span style="color: #ee44aa;">{{ moduleData.author }}</span>
            </div>

            <!--<div>
              Average User Ratings
            </div>-->
          </v-flex>
        </v-layout>
        <v-layout align-center>
          <!--<v-flex>
            <span class="title">
              <strong>5/5</strong>
            </span>
            <img height="20" :src="ratingIconOn" />
          </v-flex>-->
          <v-spacer></v-spacer>
          <v-flex
            text-md-right
          >
            <v-btn
              v-if="proceedToExam"
              color="success"
              @click.stop="goToExam"
            >Proceed to Exam</v-btn>
          </v-flex>
        </v-layout>

        <v-jumbotron
          dark
        >
          <v-container fill-height class="pa-0">
            <v-layout wrap fill-height>
              <!--<v-flex md4 fill-height style="overflow-y: auto;">
                <v-toolbar color="primary">
                  <v-toolbar-side-icon></v-toolbar-side-icon>
                  <v-toolbar-title>Slide List</v-toolbar-title>
                </v-toolbar>
                <v-list>
                  <v-list-tile v-for="(slide, i) in slides" :key="i" @click="goTo(slide.start_time)">
                    <v-list-tile-title>
                      <div :class="slide.watched ? 'green--text' : ''">{{ slide.title }}</div>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-flex>-->
              <v-flex md12 fill-height text-xs-center>
                <video
                  height="100%"
                  width="100%"
                  preload="auto"
                  ref="video"
                  controlsList="nodownload"
                  @click="handleVideoClick"
                  :src="moduleData.video"
                  :style="{ backgroundColor: 'black', cursor: 'pointer' }"
                  :poster="moduleData.image"
                >
                  <!-- <source src="https://ak4.picdn.net/shutterstock/videos/15629164/preview/stock-footage-medical-d-animation-of-the-human-thyroid.mp4" type="video/mp4"> -->
                  <!-- <source src="http://download.blender.org/peach/trailer/trailer_1080p.ogg" type="video/ogg"> -->
                  Your browser does not support the video tag.
                </video>
                <v-layout v-if="videoPaused">
                  <v-flex>
                    <div
                      @click="handleVideoClick"
                      :style="{ position: 'absolute', top: '31%', left: '45%', cursor: 'pointer' }"
                    >
                      <v-icon
                        :style="{ fontSize: '8em', background: '#8e8e8e' }"
                      >mdi-play-box-outline</v-icon>
                    </div>
                  </v-flex>
                  <v-flex>
                    <div
                      @click.stop.prevent="handleClickFullscreen"
                      :style="{ position: 'absolute', bottom: '10px', right: '10px', cursor: 'pointer',background: '#8e8e8e' }"
                    >
                      <v-icon
                        :style="{ fontSize: '4em' }"
                      >mdi-fullscreen</v-icon>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-jumbotron>

        <v-layout align-center>
          <!--<v-flex>
            <div>Rate this module</div>
            <div>
              <img v-for="i in 5" :key="i" height="16" class="ma-1" :src="ratingIconOff" />
            </div>
          </v-flex>-->
          <v-spacer></v-spacer>
          <v-flex text-md-right>
            <span>CPD Points</span>
            <v-avatar color="primary" size="30">
              <span class="white--text">{{ moduleData.cpd_points }}</span>
            </v-avatar>
          </v-flex>
        </v-layout>

        <!-- <messaging-feature></messaging-feature> -->

      </v-card>
    </v-container>
    <v-container class="mb-3">
      <v-layout wrap>
        <v-flex xs12 text-xs-right>
          <v-btn
            outline
            class="secondary secondary--text"
            to="/dashboard"
          >
            Back
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>

    <!--<related-modules></related-modules>-->

    <v-footer 
      height="112"
    >
      <main-footer></main-footer>
    </v-footer>

  </div>
</template>

<script>
import DashboardHeader from '@/components/dashboard/dashboardHeader'
import MainFooter from '@/components/mainFooter'
import MessagingFeature from '@/components/module/messagingFeature'
import RelatedModules from '@/components/module/relatedModules'

import axios from 'axios'
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    DashboardHeader,
    MainFooter,
    MessagingFeature,
    RelatedModules
  },
  computed: {
    doctorName () {
      return this.user ? this.user.nickname : ''
    }
  },
  created () {
    this.fetchData()
  },
  data: function () {
    return {
      videoPaused: true,
      vTime: 0,
      segmentWatched: 0,
      proceedToExam: false,
      slides: [
        {
          title: 'Start',
          desc: '',
          start_time: 0,
          end_time: 20,
          watched: false
        }
      ],
      moduleId: parseInt(this.$route.params.id),
      ratingIconOn: require('@/assets/svg/Group 243.svg'),
      ratingIconOff: require('@/assets/svg/Group 275.svg'),
      token: null,
      user: {},
      moduleData: {},
      percentageViewed: 0
    }
  },
  methods: {
    goToExam () {
      this.$router.push('/module/' + this.moduleId + '/assessment')
    },
    fetchData () {
      this.getModule()
    },
    getModule () {
      if (navigator.onLine) {
        axios.get(apiUrl + '/module/' + this.moduleId).then(e => {
          console.log(e.data)
          if (e.data) {
            this.moduleData = e.data
            console.log('module/index.vue', this.moduleData)
            if (this.moduleData.segments.length > 0) {
              this.slides = this.moduleData.segments
            }
          }
        }).catch(e => {
          console.log('error', e)
        })
      } else {

      }
    },
    handleVideoClick () {
      if (this.$refs.video.paused) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
      this.$set(this, 'videoPaused', this.$refs.video.paused)
    },
    handleClickFullscreen () {
      this.handleFullScreen(this.$refs.video)
    },
    handleFullScreen (doc) {
      if (
        doc.fullscreen ||
        doc.webkitIsFullScreen ||
        doc.mozFullScreen ||
        doc.msFullscreenElement
      ) {
        this.exitFullscreen(doc)
      } else {
        this.requestFullScreen(doc)
      }
    },
    requestFullScreen (docElm) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      }
    },
    fullscreenchange (document) {
      document.addEventListener('fullscreenchange', function () {
        document.fullscreen = (document.fullscreen) ? '' : 'not '
      }, false)

      document.addEventListener('mozfullscreenchange', function () {
        document.mozFullScreen = (document.mozFullScreen) ? '' : 'not '
      }, false)

      document.addEventListener('webkitfullscreenchange', function () {
        document.webkitIsFullScreen = (document.webkitIsFullScreen) ? '' : 'not '
      }, false)

      document.addEventListener('msfullscreenchange', function () {
        document.msFullscreenElement = (document.msFullscreenElement) ? '' : 'not '
      }, false)
    },
    exitFullscreen (document) {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    goTo (timeframe) {
      this.$refs.video.currentTime = timeframe
      if (this.$refs.video.paused) {
        this.$refs.video.play()
      }
      this.$set(this, 'videoPaused', this.$refs.video.paused)
    },
    checkWatchedVideo (vTime) {
      this.slides.find((value, index) => {
        if (vTime >= Number(value.start_time) && vTime <= Number(value.end_time)) {
          console.log('vtime', vTime)
          console.log('module_time', value.start_time + ' ' + value.end_time)
          // console.log(((vTime - Number(value.start_time)) / (Number(value.end_time) - Number(value.start_time))))
          this.$set(this, 'percentageViewed', (((vTime - Number(value.start_time)) / (Number(value.end_time) - Number(value.start_time))) * 100))
          if (this.percentageViewed >= 80) {
            this.$set(value, 'watched', true)
          }
        }
      })
      this.$set(this, 'segmentWatched', this.slides.filter(i => i.watched === true).length)
    }
  },
  mounted () {
    this.$refs.video.onerror = function (err) {
      console.log(err)
    }
    this.$refs.video.onended = (a) => {
      if (this.moduleData.questionnaire.length > 0) {
        if (this.segmentWatched >= this.slides.length) {
          this.goToExam()
        }
      } else {
        this.$router.push('/dashboard')
      }
    }
    this.$refs.video.addEventListener('timeupdate', (e) => {
      this.$set(this, 'vTime', e.target.currentTime)
    }, false)
  },
  props: {
    serverData: {
      default: function () {
        return []
      }
    }
  },
  watch: {
    segmentWatched (n) {
      if (n >= this.slides.length) {
        this.proceedToExam = true
      }
    },
    slides () {},
    vTime (vTime) {
      this.checkWatchedVideo(vTime)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/module/index.vue